import React from "react";

import { cn } from "@/lib/chillnn/cn";

import { InputNumber } from "@/components/ui/input/input-number";

import { FormErrorMessage, FormItem, FormLabel } from "../../../_base/form";

import type { ComponentProps } from "react";

type Props = {
	errorMessage?: string;
	textAlign?: "left" | "center" | "right";
	hiddenSpinButton?: boolean;
	needsDecimal?: boolean;

	label?: string;
} & ComponentProps<typeof InputNumber>;

/**
 * 数値入力フィールドコンポーネント
 */
export const InputNumberFieldRHF = React.forwardRef<HTMLInputElement, Props>(
	(
		{ errorMessage, hiddenSpinButton = true, textAlign = "center", needsDecimal = false, label, ...props }: Props,
		ref,
	) => {
		const textAlignStyle =
			textAlign === "center" ? "text-center" : textAlign === "right" ? "text-right" : "text-left";
		const hiddenSpinButtonStyle = hiddenSpinButton ? "hidden-spin-button" : "";

		return (
			<FormItem>
				<FormLabel>{label}</FormLabel>

				<InputNumber
					className={cn(textAlignStyle, hiddenSpinButtonStyle)}
					needsDecimal={needsDecimal}
					{...props}
					ref={ref}
				/>
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</FormItem>
		);
	},
);
